"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module opensearch/formats/suggestions-json
 */

/**
 * Class to parse SuggestionsJSONFormat results
 * @constructor SuggestionsJSONFormat
 */
var SuggestionsJSONFormat = exports.SuggestionsJSONFormat = function () {
  function SuggestionsJSONFormat() {
    _classCallCheck(this, SuggestionsJSONFormat);
  }

  _createClass(SuggestionsJSONFormat, [{
    key: "parse",


    /**
     * Parse the given JSON.
     * @param {string} text The JSON string to parse.
     * @returns {module:opensearch/formats.Suggestion[]} The parsed suggestions
     */
    value: function parse(text) {
      var result = JSON.parse(text);

      var _result = _slicedToArray(result, 4),
          completions = _result[1],
          descriptions = _result[2],
          urls = _result[3];

      return completions.map(function (completion, index) {
        return {
          completion: completion,
          description: descriptions && descriptions[index],
          url: urls && urls[index]
        };
      });
    }
  }]);

  return SuggestionsJSONFormat;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/formats/suggestions-json.js